import palette from '../theme/palette';

const styleOverrides = {
  root: {
    minHeight: '31px',
    borderBottom: `1px solid ${palette.divider}`,
  },
  indicator: {
    left: 0,
  },
};

export default styleOverrides;
